<template>
  <div>
    <form @submit.prevent="submit()">

      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'titulo'"
            v-model="formulario.menu" 
            :placeholder="'Nome'"
            data-vv-as="Nome"
            v-validate="'required|max:255'"
            :error="validationErrors.first('titulo')"
         />
      </div>   

      <div class="mb-3">
        <SGPFormSelectComponent 
            :name="'acl_menu_id'"
            :listaDeOptions="listaDeMenus"
            v-model="formulario.acl_menu_id"
            :optionLabel="'menu'"
            :placeholder="'Menu Principal'"
            :error="validationErrors.first('acl_menu_id')"
            data-vv-as="Menu Principal"
            @change="atualizarOrdenacao($event)"
        />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'route_name'"
            v-model="formulario.route_name" 
            :placeholder="'Router Name'"
            data-vv-as="Router Name"
            v-validate="'max:255'"
            :error="validationErrors.first('route_name')"
        />
      </div>

      <div class="mb-3">
        <SGPFormInputComponent 
            type="text" 
            :name="'route_link'"
            v-model="formulario.route_link" 
            :placeholder="'Route Link'"
            data-vv-as="Route Link"
            v-validate="'max:255'"
            :error="validationErrors.first('route_link')"
        />
      </div>

      <div class="container-botoes">
        <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
          {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
        </button>
        <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="fecharModal()">Cancelar</button>
      </div>
      
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "FormularioMenuComponent",

  props: {
    tipoFormulario: {
      type: String,
      default: 'salvar'
    },
    menu: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    let paramAclMenuId = this.menu?.acl_menu_id || 0;
    this.listarOrdenacao(paramAclMenuId);

    return {
      formulario: (this.menu?.id) ? this.menu : {
        menu: '',
        acl_menu_id: '',
        route_name: '',
        route_link: ''
      }
    }
  },

  computed: {
    ...mapGetters('menus', ['listaDeMenus','listaDeOrdenacao']),
    ...mapGetters('submodulos', ['listaDeSubModulos']),
    ...mapGetters('vueComponentesMenus', ['listaDeVueComponentesMenus'])
  },

  methods: {
    ...mapActions('menus', [
      'salvarMenu',
      'buscarMenu',
      'atualizarMenu',
      'listarOrdenacao'
    ]),
    ...mapActions('submodulos', ['listarSubModulos']),
    ...mapActions('vueComponentesMenus', ['listarVueComponentesMenus']),

    atualizarOrdenacao(event) {
      if(typeof event == 'undefined'){
        return false;
      }
      let aclMenuId = (this.formulario.acl_menu_id != '') ? this.formulario.acl_menu_id : 0;
      this.listarOrdenacao(aclMenuId);
    },

    limparCampos () {
      this.formulario.menu = '';
      this.formulario.acl_menu_id = '';
      this.formulario.route_name = '';
      this.formulario.route_link = '';
      this.$validator.reset();
    },

    submit () {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if(this.tipoFormulario === 'salvar') {
            const resp = await this.salvarMenu(this.formulario);
            if(!resp) return;
          } else {
            const resp = await this.atualizarMenu(this.formulario);
            if(!resp) return;
          }
          this.limparCampos();
          this.fecharModal();
        }
      });     
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  },

  beforeMount(){
    // this.listarSubModulos();
    // this.listarVueComponentesMenus();
  }
}
</script>
